import { writable } from "svelte/store";
import { firebase } from "../firebase";
import db from "../firebase";
import { navigate } from "svelte-routing";
import { searchDoc, error404, proces200, panelController } from "./service";



export const validkey = async (value) => {
  const datan = await searchDoc({
    collection: "service",
    data: ["idServices", "==", value.id],
  });
  if (datan.status === true) {
    let findDoc = datan.data[0].doc.listRatinggs.find(
      (item) => item.config.id === value.key
    );
    if (findDoc) {
      /* console.log("validkey -->", {
        index: datan.data[0].doc.listRatinggs.indexOf(findDoc),
        datan,
      }); */
      return { index: datan.data[0].doc.listRatinggs.indexOf(findDoc), datan };
    }
  }
  return { index: false, datan };
};

export const userAuth = writable([]);
export const userRol = writable(null);
                                                                                                                                                                                                                                                                                    
const createUser = () => {
  const { subscribe, set } = writable(false);

  return {
    subscribe,
    setUser: (user) => {
      set(user);

     /*  validAdmin(user); */
    },
    current: async () => {
      const user = await firebase.getCurrentUser();
      set(user);

     /*  validAdmin(user); */
    },
  };
};

export const user = createUser();

export async function CrearAdmin(objeto) {
  try {
    const docRef = await db.collection("admin").add({
      fecha: firebase.firestore.Timestamp.fromDate(new Date()),
      displayName: objeto,
    });
    /*           console.log('Documento creado con ID:', docRef.id);
     */ /* navigate('/panel', { replace: true }) */
    proces200();
    readDoc("admin").then(
      function (value) {
        admin.set(value); // Actualiza el estado de Svelte con los datos
      },
      function (error) {
        error404();
        console.error("Error al leer documentos:", error);
      }
    );
  } catch (error) {
    error404();
  }
}

export const admin = writable([]);

export async function readDoc(index) {
  const dataList = {status:false,data:[],id:[]};
  try {
    const querySnapshot = await db.collection(index).get();
    
    querySnapshot.forEach((doc) => {
      dataList.data.push(...doc.data());
      dataList.id,push(doc.id);
    });
    dataList.status = true;
  } catch (error) {
    dataList.status = false;
    /* panelController.update((v) => {
      v.erros.push({
        date:New Date()
      }) = admin.data[0].doc;
      v.firebase.docs[0].id=admin.data[0].id;
      return v;
    }); */
     }
  return dataList;
}

export async function readServices(doc) {/* 
  console.log(doc); */
  let dataList = {status:false,data:[]};
    const doca = await db.collection(doc.collection).doc(doc.id);
    const observer = doca.onSnapshot(docSnapshot => {
      
      dataList.data = docSnapshot.data();
      panelController.update((service)=>{ 
          service.service = dataList.data;
        return service;
      });
    }, err => {
      dataList.error = err;
      
    });
    
    /* console.log(dataList); */
  return dataList;
}

export async function deleteDoc(id, doc) {
  /* console.log("user id", user.id); */
  try {
    await db.collection(doc).doc(id).delete();

    readDoc(doc).then(
      function (value) {
        admin.set(value); // Actualiza el estado de Svelte con los datos
        proces200();

        /*       console.log("Datos leídos:", value);
         */
      },
      function (error) {
        console.error("Error al leer documentos:", error);
        error404();
      }
    );
  } catch (error) {
    console.error("Error al leer documentos:", error);
    error404();
    throw error; // Lanza el error para que pueda ser manejado en otro lugar si es necesario
  }
}
